module.exports = __webpack_public_path__ + "static/media/assets_sprite_map.fe5aab9c.png";